import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { Dropdown, List, Stack, Text } from '@fluentui/react';
import { AuthContext } from '../AuthContext';

const rootUrl = window.location.protocol + '//' + window.location.host + '/';
const dropdownStyles = {
    root: {
        maxWidth: '400px',
        marginBottom: '15px;'
    },
    callout: {
        maxHeight: '300px',
    },
    optionsContainerWrapper: {
        maxHeight: '300px',
    },
    optionsContainer: {
        maxHeight: '300px',
    },
};
const deviceHeading = {
    fontWeight: 'bold'
}
const deviceItemStyle = {
    borderStyle: "none",
    borderWidth: "1px",
    padding: "5px"
}
const spacingTokens = {
    childrenGap: 10,
    padding: 10,
};
export const AuvikDeviceReport = () => {
    const authContext = useContext(AuthContext);
    const [tenantItems, setTenantItems] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [firewalls, setFirewalls] = useState([]);
    const [routers, setRouters] = useState([]);
    useEffect(() => {
        if (tenantItems.length == 0 && authContext.accessToken && authContext.isNocProf) {
            axios.get(rootUrl + 'AuvikReport/GetTenants',
                { headers: { 'Authorization': "bearer " + authContext.accessToken } }).then((
                    result) => {
                    var items = result.data.map((item, ind) => {
                        return { key: item.id, text: item.name }
                    });
                    setTenantItems(items);
                });
        }
    }, []);
    useEffect(() => {
        if (selectedCompany) {
            axios.get(rootUrl + 'AuvikReport/GetDevices/' + selectedCompany.key,
                { headers: { 'Authorization': "bearer " + authContext.accessToken } }).then(
                    (result) => {
                        var fwalls = result.data.filter(d => d.deviceType == "Firewall");
                        var rtrs = result.data.filter(d => d.deviceType == "Router")
                        setFirewalls(fwalls);
                        setRouters(rtrs);
                    });
        }
    }, [selectedCompany]);
    const onRenderDevice = (item, index) => {
        return (<div style={deviceItemStyle}>
            <Text variant={'large'} style={deviceHeading}>{item.name}</Text>
            <Stack horizontal disableShrink wrap tokens={spacingTokens}>
                <Stack.Item><Text style={deviceHeading} variant={'mediumPlus'}>Manufacturer:</Text> <Text variant={'medium'}>{item.manufacturer}</Text></Stack.Item>
                <Stack.Item><Text style={deviceHeading} variant={'mediumPlus'}>Firmware Version:</Text> <Text variant={'medium'}>{item.firmwareVersion}</Text></Stack.Item>
                <Stack.Item><Text style={deviceHeading} variant={'mediumPlus'}>Software Version:</Text> <Text variant={'medium'}>{item.softwareVersion}</Text></Stack.Item>
                <Stack.Item><Text style={deviceHeading} variant={'mediumPlus'}>Make/Model:</Text> <Text variant={'medium'}>{item.makeModel}</Text></Stack.Item >
                <Stack.Item><Text style={deviceHeading} variant={'mediumPlus'}>Last Seen:</Text> <Text variant={'medium'}>{item.lastSeen}</Text></Stack.Item >
                <Stack.Item><Text style={deviceHeading} variant={'mediumPlus'}>Serial #:</Text> <Text variant={'medium'}>{item.serialNumber}</Text></Stack.Item >
                <Stack.Item>{item.deciveType}</Stack.Item>
            </Stack>
        </div >)
    }
    return (
        <div>
            <img style={{paddingBottom:"25px"}}alt="Networking Technologies logo" src="/NetworkingTechnologies_Horiz.png" className='d-print-block d-none' height="100"/>
            <h1>Auvik Device Report</h1>
            <Dropdown
                placeholder='Select Company to View'
                label='Company'
                options={tenantItems}
                styles={dropdownStyles}
                className="d-print-none"
                onChange={(evt, item) => { setSelectedCompany(item) }} />
            {selectedCompany &&
                <h2>{selectedCompany.text}</h2>
            }
            {firewalls.length > 0 &&
                <div>
                    <h3>Firewalls</h3>
                    <List items={firewalls}
                        onRenderCell={onRenderDevice} />
                </div>
            }
            {routers.length > 0 &&
                <div>
                    <h3>Routers</h3>
                    <List items={routers} onRenderCell={onRenderDevice} />
                </div>
            }


        </div>);
}